import { PropsWithChildren, useMemo, useState } from "react";
import { PositionsSort } from "@shared/features/portfolio/types.ts";
import { ConsolidatedCoinData, SortingOrder } from "@shared/types";
import { PositionsContext } from "features/portfolio/Positions/Positions.context.ts";

const PositionsProvider = ({ children }: PropsWithChildren) => {
  const [sortBy, setSortBy] = useState<PositionsSort>(PositionsSort.MARGIN);
  const [sortDirection, setSortDirection] = useState<SortingOrder>(
    SortingOrder.DESCEND
  );
  const [changeLeverageCoinData, setChangeLeverageCoinData] = useState<
    ConsolidatedCoinData | undefined
  >();

  const contextValue = useMemo(
    () => ({
      sortBy,
      setSortBy,
      sortDirection,
      setSortDirection,
      changeLeverageCoinData,
      setChangeLeverageCoinData,
    }),
    [sortBy, sortDirection, changeLeverageCoinData]
  );

  return (
    <PositionsContext.Provider value={contextValue}>
      {children}
    </PositionsContext.Provider>
  );
};

export default PositionsProvider;
